import {
    AmountWrapper,
    DenomBox,
    DenomBoxWrapper,
    HeaderParagraphText,
} from '@/src/modules/build-a-card/StyledComponents'
import { defaultDenominations } from '@/src/modules/build-a-card/constants'
import { useEffect, useState } from 'react'
import RequiredAsterisk from '@/src/common/components/elements/Forms/RequiredAsterisk'
import { TMinMaxFromGYPMerchant } from '@/src/modules/build-a-card/types'

const getDenominations = (
    denominationArr: number[],
    minMaxAndFixed: TMinMaxFromGYPMerchant,
    useFixed: boolean
) => {
    const { brand_min, brand_max, egift } = minMaxAndFixed
    const fixedValues = egift?.fixed ?? []

    // if fixed values available and want to use, return fixed only
    if (useFixed && fixedValues?.length > 0) {
        return fixedValues
    }

    return denominationArr.filter(function (denomination) {
        return denomination >= brand_min && denomination <= brand_max
    })
}

type TDefaultDenomProps = {
    denomination: string
    onDenominationChange: (denom: string) => void
    minMaxAndFixed: TMinMaxFromGYPMerchant
    label: string
    partner?: string
}

const DefaultDenominationOptions = ({
    denomination,
    onDenominationChange,
    minMaxAndFixed,
    label = 'First, choose an amount for each of your gifts:',
    partner,
}: TDefaultDenomProps) => {
    // !!partner is so useFixed is only used in partner flow
    const denominations = getDenominations(
        defaultDenominations,
        minMaxAndFixed,
        !!partner
    )
    const [selected, setSelected] = useState<number>()

    useEffect(() => {
        setSelected(Number(denomination))
    }, [denomination])

    return (
        <AmountWrapper>
            <HeaderParagraphText>
                {label}
                <RequiredAsterisk />
            </HeaderParagraphText>
            <DenomBoxWrapper>
                {denominations.map((denom: number) => {
                    return (
                        <DenomBox
                            key={`${denom}-button`}
                            id={`${denom}-button`}
                            label={`$${denom}`}
                            onClick={() =>
                                onDenominationChange(denom.toFixed(2))
                            }
                            variant={
                                denom === selected
                                    ? 'graySquareButtonActive'
                                    : 'graySquareButton'
                            }
                            type={'button'}
                        />
                    )
                })}
            </DenomBoxWrapper>
        </AmountWrapper>
    )
}

export default DefaultDenominationOptions
